import { render, staticRenderFns } from "./HistoriaClinicaV2.vue?vue&type=template&id=72b458b4&scoped=true"
import script from "./HistoriaClinicaV2.vue?vue&type=script&lang=js"
export * from "./HistoriaClinicaV2.vue?vue&type=script&lang=js"
import style0 from "./HistoriaClinicaV2.vue?vue&type=style&index=0&id=72b458b4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72b458b4",
  null
  
)

export default component.exports